<h3 class="mb-3">{{ 'lombard.initial.conditions.headline' | transloco }}</h3>
<div class="box">
  <ng-template #condition let-value="value" let-key="key" let-hasInfo="hasInfo" let-isNumeric="isNumeric">
    <div class="row mb-1">
      <div class="col-7 text-size-large text-bold">
        {{ 'lombard.initial.conditions.' + key | transloco }}
        @if (hasInfo) {
          <svg class="icon icon-16 cursor-pointer ml-1" (click)="modal.open(modalContent, { size: 'lg' })">
            <use xlink:href="/assets/img/svgs/svgset.svg#info-23" />
          </svg>
          <ng-template #modalContent let-modal>
            <web-design-system-modal
              [headline]="'lombard.initial.conditions.' + key + 'Info.headline' | transloco"
              (dismiss)="modal.dismiss('Cross click')"
            >
              <p>{{ 'lombard.initial.conditions.' + key + 'Info.body' | transloco }}</p>
            </web-design-system-modal>
          </ng-template>
        }
      </div>
      <div class="col-5 text-right text-size-large text-bold">
        @if (isNumeric) {
          {{ value }}
        }
        @if (!isNumeric) {
          {{ 'lombard.initial.conditions.' + value | transloco }}
        }
      </div>
    </div>
  </ng-template>
  <ng-container
    *ngTemplateOutlet="
      condition;
      context: { hasInfo: true, key: 'creditInterest', value: (lombard.creditInterest | number: '1.2-2') + ' % p.a.', isNumeric: true }
    "
  />
  <ng-container
    *ngTemplateOutlet="condition; context: { key: 'creditInterestBillingPeriod', value: lombard.creditInterestBillingPeriod }"
  />
  <ng-container *ngTemplateOutlet="condition; context: { key: 'creditPeriod', value: lombard.creditPeriod }" />
  <ng-container *ngTemplateOutlet="condition; context: { key: 'creditRepayment', value: lombard.creditRepayment }" />
</div>
